import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
  padding: 16px;
  margin-top: 24px;
  border-radius: 8px;
  background-color: #F4F4F4;
`;

export const Title = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 19.36px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const Description = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #18181B;
`;